import Controller from './admin/ckeditor_extension_controller'
export default Controller